import { lazy, Suspense } from "react";
import LoadingFeedback from "@/components/shared/loading/LoadingFeedback";

const Positions = lazy(() => import("../pages/PositionsManagment"));
const NewPosition = lazy(() => import("../pages/NewPosition"));
const PositionDetails = lazy(() => import("../pages/PositionDetails"));
const CandidatesStagesPosition = lazy(() => import("../pages/ApplicationsStagesPosition"));

export const positionsRoutes = [
  {
    path: "/positions",

    children: [
      {
        path: "",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <Positions />
          </Suspense>
        ),
      },
      {
        path: ":id",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <NewPosition />
          </Suspense>
        ),
      },
      {
        path: "stages/:positionId",
        element: (
          <Suspense>
            <PositionDetails />
          </Suspense>
        ),
      },
      {
        path: "stages/:positionId/stage/:stageId",
        element: (
          <Suspense>
            <CandidatesStagesPosition />
          </Suspense>
        ),
      },
    ],
  },
];
